(() => {
  const ROOT = '[data-pvx]';

  const init = (root) => {
    if (!root || root.dataset.pvxReady) return;
    root.dataset.pvxReady = '1';

    const track = root.querySelector('.pvx-js-track');
    const btnPrev = root.querySelector('.pvx-js-prev');
    const btnNext = root.querySelector('.pvx-js-next');
    const nav = root.querySelector('[class*="pvx__nav-"]');

    if (!track || !btnPrev || !btnNext) return;

    const getItems = () => Array.from(track.querySelectorAll('a'));

    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);

    const getSnapPoints = () => {
      const items = getItems();
      if (!items.length) return [];

      const firstOffset = items[0].offsetLeft;

      return items.map((item) => {
        const point = item.offsetLeft - firstOffset;
        return Math.max(0, Math.min(point, maxScroll()));
      });
    };

    const getNextIndex = () => {
      const points = getSnapPoints();
      const x = track.scrollLeft;

      for (let i = 0; i < points.length; i++) {
        if (points[i] > x + 2) return i;
      }

      return points.length - 1;
    };

    const getPrevIndex = () => {
      const points = getSnapPoints();
      const x = track.scrollLeft;

      for (let i = points.length - 1; i >= 0; i--) {
        if (points[i] < x - 2) return i;
      }

      return 0;
    };

    const scrollToIndex = (index) => {
      const points = getSnapPoints();
      if (!points.length) return;

      const clampedIndex = Math.max(0, Math.min(index, points.length - 1));
      const left = points[clampedIndex];

      track.scrollTo({
        left,
        behavior: 'smooth'
      });
    };

    const updateBtns = () => {
      const x = Math.round(track.scrollLeft);
      const max = Math.round(maxScroll());
      const noOverflow = max <= 0;

      const atStart = x <= 1;
      const atEnd = x >= max - 1;

      btnPrev.classList.toggle('is-disabled', noOverflow || atStart);
      btnNext.classList.toggle('is-disabled', noOverflow || atEnd);

      if (nav) {
        nav.style.display = noOverflow ? 'none' : '';
      }
    };

    btnPrev.addEventListener('click', () => {
      scrollToIndex(getPrevIndex());
    });

    btnNext.addEventListener('click', () => {
      scrollToIndex(getNextIndex());
    });

    track.addEventListener('scroll', updateBtns, { passive: true });
    window.addEventListener('resize', updateBtns);

    track.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', updateBtns, { once: true });
      img.addEventListener('error', updateBtns, { once: true });
    });

    requestAnimationFrame(updateBtns);
    setTimeout(updateBtns, 300);
  };

  document.querySelectorAll(ROOT).forEach(init);

  const mo = new MutationObserver((muts) => {
    muts.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.(ROOT)) init(node);
        node.querySelectorAll?.(ROOT).forEach(init);
      });
    });
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();